<template>
    <div id="vy_main" style="overflow-x:hidden">
      <main>
        <!--ヘッダー-->
        <HeaderArea />

        <div id="main_area">
          <h2>利用規約（ボラ活エール）</h2>
          <div id="Policy_Condition_area">
            <b>１．システムの利用者</b><br>
            これは、サービスの提供者と利用者の間を取り持つためのシステムであり、従って大きく分けて以下の２種類の利用者を想定します。<br><br>
            （１）サービス提供者<br>
            このシステムが提供する「サービス提供支援機能」を通じて、一般利用者にサービスを提供する人または団体。<br><br>
            （２）一般利用者<br>
            このシステムが提供する「サービス利用支援機能」を通じて、サービス提供者のサービスを利用する人または団体。<br>
            <br>

            <b>２．利用規約の目的</b><br>
            この利用規約は、「一般利用者」向けであり、上記の「サービス利用支援機能」の利用に関する規約です。<br>
             「サービス提供者」とは、別途提供される「サービス提供支援機能」（これは一般利用者には提供されない）について、個々に使用許諾契約を締結します。<br>
            <br>

            <b>３．用語の定義</b><br>
            （１）社協<br>
            正しくは「社会福祉協議会」であり、通常市区町村毎に設けられた社会福祉分野の公的機関です。<br><br>
            （２）ボランティア<br>
            社会福祉的な機関が実施する活動に対して無償で労力を提供すること及びそれを行う人を指します。<br><br>
            （３）体験ボランティア<br>
            上記ボランティアを体験実習すること及び体験実習する人で、通常高学年児童や学生が対象となります。<br><br>
            （４）ボランティア体験プログラム<br>
            主に青少年がボランティアを実際に体験できるように、社協が毎年定期的に実施する企画行事及びその企画の公開情報を指します。<br>
            <br>

            <b>４．サービスの内容</b><br>
            当システムが提供する「サービス利用支援機能」には、以下の２種類があります。<br>
            <br>
            （１）体験ボランティア<br>
            社協が実施する「ボランティア体験プログラム」の運営を支援し、利用者に「サービス利用支援機能」を提供します。<br>
            <br>
            ① 利用条件<br>
            対象利用者は主に青少年であり、社協が上記プログラムを開催する期間のみ利用が可能となります。利用者は、システムを通じてアカウントを取得し、社会福祉団体への斡旋に必要となる個人情報の登録を行う必要があります。<br>
            <br>
            ② サービスの提供者<br>
            社協が管轄地域の社会福祉団体における同地域に住む青少年のボランティア体験を支援するために、当システムを通じて「ボランティア体験プログラム」を公開し、参加申込みを受け付けることにより「体験ボランティア」の斡旋業務を行います。<br>
            <br>
            ③ サービスの利用者<br>
            上記「ボランティア体験プログラム」を参照し、本システムを通じて参加登録を行います。登録が承認されると利用者は、その実施日に当該社会福祉施設においてボランティア体験を行います。その際、本システムを通じてチェックイン／アウトを行います。規定日数の参加が確認されると「アンケート＆感想文」の提出が要請され、提出後に「参加証明書」がダウンロード可能となります。以上が一連の流れです。<br><br>

            （２）ボランティアの斡旋<br>
            社協は、上記体験ボランティアだけでなく、実際のボランティアの斡旋も行っていますが、その支援機能は現時点ではまだリリースされていません。<br>
            <br>

            <b>５．利用規約の変更について</b><br>
            本利用規約は、当システムのサービス内容の追加、変更に応じて、随時追加、変更されるものとします。<br>
            <br>

            <b>６．権利の帰属</b><br>
            （１）個人情報<br>
            一般利用者が本システムに登録した個人情報の著作権は、登録した本人に帰属し、本システムを通じて本人以外に公開されることはありません。サービス提供者は、本システムが支援する「サービス提供支援機能」の対象業務の範囲内でのみそれを利用することができます。<br><br>
            （２）公開情報<br>
            本システムを通じて公開される種々の情報の著作権は、その作成者に帰属します。<br>
            <br>

            <b>７．禁止事項</b><br>
            利用者は、本システムの利用において、以下に挙げる禁止事項を行ってはいけません。<br><br>
            （１）目的外使用<br>
            本システムをサービス提供者のサービスを受ける以外の目的で使用してはいけません。<br><br>
            （２）妨害行為<br>
            他の利用者が本システムを利用することを妨害するような行為をしてはいけません。以下は、妨害行為の例です。<br><br>
            ① １人で複数のアカウントを取得すること。<br>
            ② 必要以上の参加申込みを行うこと。<br>
            ③ 想定されている方法以外でシステムにアクセスしたり、過度な負荷を与えること。<br>
            ④ 本システムの利用を他人に強要したり、逆に禁止、妨害したりすること。<br><br>
            （３）著作権の侵害<br>
            本システムを通じて公開される情報の著作権を侵害してはいけません。<br>
            <br>

            <b>８．アカウントの停止</b><br>
            上記禁止事項への違反と判断した場合には、サービスの提供者またはシステムの運営者は、その利用者のアカウントを停止することがあります。<br>
            <br>
            <b>９．サービスの提供、停止、終了に関して</b><br>
            本システムを通じて提供されるサービスは、以下の理由により停止、終了することがあります。<br><br>
            （１）サービス提供期間の終了<br>
            本システムを通じて提供されるサービスの中には、その提供期間が限定されているサービスがあります。<br><br>
            （２）サービス提供者の都合による停止、終了<br>
            サービス提供者の事情により、サービス提供に支障が生じたり、停止、終了が必要と判断された場合には、サービスが停止、終了することがあります。<br><br>
            （３）システム運営者の都合による停止、終了<br>
            システム運用者の事情により、サービス提供に支障が生じたり、停止、終了が妥当と判断された場合には、サービスが停止、終了することがあります。<br>
            <br>

            <b>１０．損害賠償</b><br>
            本システムの利用により利用者が損害を被った場合、その原因がサービス提供者にあると判断される場合には、サービス提供者がその解決にあたります。またその原因がシステム
            運営者にあると判断される場合には、システム運営者がその解決にあたります。<br>
            <br>

            <b>１１．管轄裁判所</b><br>
            上記に関わる訴訟は、利用者の住所に関わらずさいたま地方裁判所を管轄裁判所とさせていただきます。<br><br>

            <div style="width:100%;text-align:right">以上</div>
            
          </div>
        </div>
        <!--フッター-->
        <FooterArea />
      </main>
    </div>

    
     <!-- スマホ専用ボタン（フローティングメニューの上に配置） -->
     <div class="vy-responsive-menu-container floating_over"  style="
          padding: 10px 0;
          background: rgba(0, 0, 0, .5);
          border: 0px;
          justify-content: space-evenly;">
          <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: white;color:#4175d0;border:1px solid #000"  v-on:click="return_page()">戻る</button>
          
      </div>
</template>
  
    
<script setup>
  /* eslint-disable */
  import HeaderArea from './HomeHeader.vue'
  import FooterArea from './HomeFooter.vue'

    
  /* 表示する子コンポーネント関係の情報 */
  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント
  import { shallowRef, watch, ref } from 'vue'
  import { useRouter } from 'vue-router'
  const router = useRouter()
  const content = shallowRef('')

  const return_page = () =>{
    if(router.go(-1)){
      alert(router.go(-1))
      router.go(-1)
    }else{
      window.close()

    }
  }
/*
  // 選択中の社協
  let shakyo = ref("kawagoe")

  
  let Taiken = function(){
    let set_path = "/"+shakyo.value+"/Taiken"
    window.open(set_path,"_blank")
  }

  let Volunter = function(){
    alert("準備中です。")
  }

  let ShakyoPolicy = function(){
    let set_path = "/"+shakyo.value+"/Taiken/Policy"
    window.open(set_path,"_blank")
  }*/
</script>
  
<style scoped>

  #main_area{
    margin-top:30px;
    width:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #link_area{
    font-size: 17px;
    display: flex;
    justify-content: space-evenly;
    width: 50%;
    height: 200px;
    align-items: center;
    flex-direction: column;
  }
  #link_area span{
    color:black;
    cursor: pointer;
    text-decoration-line:underline
  }
/* レスポンシブ対応 */
@media screen and (max-width: 960px) {
  /*スマホ*/
  .jokyo_table {
    margin-top: 10px;
  }
.floating_over{
        display: flex
    }
}
@media screen and (min-width: 961px) {
  /*PC*/
  .jokyo_table {
    max-width: 700px;
  }
  .floating_over{
    display: none
  }
}


</style>
  